import { render, staticRenderFns } from "./Seatmap.vue?vue&type=template&id=1f5c84c3&scoped=true&"
import script from "./Seatmap.vue?vue&type=script&lang=js&"
export * from "./Seatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5c84c3",
  null
  
)

export default component.exports